import PT_BR from './pt-BR'

const i18nDictionary = {
  'pt-BR': PT_BR
}

export default i18nDictionary
